// extracted by mini-css-extract-plugin
export default {"Container":"CustomContent_Container__pLmir","TopInfo":"CustomContent_TopInfo__ul8qG","Text":"CustomContent_Text__ypxB3"};